// Definition of Enum Constants

export enum Message {
    SIGN_IN_PROFILE = "SIGN_IN_PROFILE",
    SIGN_OUT_PROFILE = "SIGN_OUT_PROFILE",
    CHANGE_SUCCESS = "CHANGE_SUCCESS",
    UPDATE_PROFILE = "UPDATE_PROFILE",
    UPLOAD_SUCCESS = "UPLOAD_SUCCESS",
    UPLOAD_ERROR = "UPLOAD_ERROR",
    DELETE_MEMBER = "DELETE_MEMBER",
    ADD_MEMBER = "ADD_MEMBER",
    INVITE_MEMBER = "INVITE_MEMBER",
    DELETE_ACCOUNT = "DELETE_ACCOUNT",
    OTP_SUCCESS = "OTP_SUCCESS",
    COPY_TO_CLIPBOARD = "COPY_TO_CLIPBOARD",
    File_NOT_FOUND = "File_NOT_FOUND",
    STRIPE_ERROR = "STRIPE_ERROR",
}

export enum Plan {
    Felix_Basic = 'FELIX_BASIC',
    Felix_Premium = 'FELIX_PREMIUM',
    Felix_Prime = 'FELIX_PRIME',
}

export enum Member {
    MEMBER = 'MEMBER',
    INVITE = 'INVITE',
}

export enum Job {
    Manufacturer = 'MANUFACTURER',
    Trader = 'TRADER',
}

export enum CompanySize {
    Zero_Ten = 'ZERO_TEN',
    Ten_Fifty = 'TEN_FIFTY',
    Fifty_Plus = 'FIFTY_PLUS',
}

export enum TenderType {
    Goods = 'GOODS',
    Service = 'SERVICE',
    Both = 'BOTH',
}

export enum Budget {
    Minus_Five_Hundred = 'MINUS_FIVE_HUNDRED',
    Five_Hundred_One_Million = 'FIVE_HUNDRED_ONE_MILLION',
    One_Million_Plus = 'ONE_MILLION_PLUS',
}

export enum Grant {
    Minus_Five_Hundred = 'MINUS_FIVE_HUNDRED',
    Five_Hundred_One_Million = 'FIVE_HUNDRED_ONE_MILLION',
    One_Million_Plus = 'ONE_MILLION_PLUS',
}

export enum Branch {
    Tenders = 'TENDERS',
    Grants = 'GRANTS',
}

export enum Source {
    US_Tenders = 'US_TENDER',
    US_Grants = 'US_GRANT',
    Europe_Tenders = 'EUROPE_TENDER',
    Europe_Grants = 'EUROPE_GRANT',
    Canada_Tenders = 'CANADA_TENDER',
    Canada_Grants = 'CANADA_GRANT',
}

export enum OverallStatus {
    Met = 'Met',
    Partially_Met = 'Partially Met',
    Not_Met = 'Not Met',
    Further_Investigation_Required = 'Further Investigation Required',
}

export enum TopFilter {
    Basic_Search = 'BASIC_SEARCH',
    Felix_Fusion_Picks = 'FELIX_FUSION_PICKS',
}

export enum Snapshot {
    Solicitation_Name = 'Solicitation Name',
    Issue_Date = 'Issue Date',
    End_User_Name = 'Enduser Name',
    End_User_Address = 'Enduser Address',
    Submission_Deadline = 'Submission Deadline',
    Questionnaire_Deadline = 'Questionnaire Deadline',
    Submission_Method = 'Submission Method',
    Type_Of_Purchase = 'Type of Purchase',
    Goods_Description = 'Goods Description',
    Training = 'Training',
    Installation = 'Installation',
    Preventive_Maintenance = 'Preventive Maintenance',
    Spare_Part_Kit = 'Spare Part Kit',
    Any_Standard_Approval  = 'Any Standard/Approval',
    Warranty = 'Warranty',
    Evaluation_Method = 'Evaluation Method',
    Requested_Delivery_Date = 'Requested Delivery Date',
    Delivery_Term = 'Delivery Term',
    Delivery_Location = 'Delivery Location',
    Payment_Term = 'Payment Term',
    Notes = 'Notes',
}

export enum Country {
    Canada = 'CANADA_TENDER',
    Europe = 'EUROPE_TENDER',
    USA = 'US_TENDER',
}